export default () => `
  query {
    checkout {
      applePay {
        isAvailable
        expressCheckoutRequest
        authorizePaymentUrl
      }
    }
    paths {
      authorizeMerchantsUrl
      termsAndConditionsUrl
      updateCheckoutAdressUrl
      updateCheckoutDeliveryUrl
      updateCheckoutRegistrationUrl
    }
  }
`
